var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoldenStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33062 11.8333L4.41205 14.2268L5.47745 9.76036L1.99023 6.77318L6.56726 6.40624L8.33062 2.16663L10.0939 6.40624L14.671 6.77318L11.1838 9.76036L12.2492 14.2268L8.33062 11.8333Z",
    fill: "#F29100"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoldenStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/golden_star.e7bcd4f0.svg";
export { ForwardRef as ReactComponent };